<template lang="pug">

    main#app.page

      //- SVG sprite include
      include assets/img/svg-symbols.svg

      .pinkmanGame
        .pinkmanGame__background(:style="{ 'background-image': backgroundImage }" ref="gameBackground")

        transition(name="fade" mode="out-in")
          component(:is="activePage")

        FooterItem

</template>

<script>
  import { mapState, mapMutations, mapGetters } from 'vuex';
  import anime from 'animejs';

  import Welcome from '@/pages/Welcome.vue'
  import Question from '@/pages/Question.vue'
  import Result from '@/pages/Result.vue'
  import FooterItem from '@/components/FooterItem.vue';

  export default {
    name: 'app',
    components: {
      Welcome,
      Question,
      Result,
      FooterItem
    },
    computed: {
      ...mapState([
        'activePage',
        'backgroundImage',
        'backgroundColor',
        'score'
      ]),
      ...mapGetters([
        'currQuest'
      ])
    },
    watch: {
      backgroundColor: {
        handler() {
          anime({
            targets: this.$refs.gameEl,
            backgroundColor: this.backgroundColor,
            duration: 1200,
            ease: 'easeOutSine',
          });
        }
      }
    },
    methods: {
      ...mapMutations([
        'changePage',
        'changeScore',
      ])
    }
  }
</script>
<style lang="stylus">
  @import "css/main.styl";
  .pinkmanGame
    position relative

    &__background
      background-size contain
      background-position center center
      background-repeat no-repeat
      position: absolute
      left: 0
      top: 0
      height: 100%
      width: 100%
      opacity: 0
</style>
